import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { ServiceComponent } from './service/service.component';
// import { ContactUsComponent } from './contact-us/contact-us.component';
import { GalleryComponent } from './gallery/gallery.component';
import { HomeComponent } from './home/home.component';
import { NewAboutUsComponent } from './new-about-us/new-about-us.component';
import { NewServiceComponent } from './new-service/new-service.component'
import { WhyUsComponent } from './why-us/why-us.component'
import { NewContactUsComponent } from './new-contact-us/new-contact-us.component'
import { ServicePortfolioComponent } from './new-service/service-portfolio/service-portfolio.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: '', redirectTo: '/about', pathMatch: 'full' },
  { path: 'service', component: NewServiceComponent },
  { path: '', redirectTo: '/service', pathMatch: 'full' },
  { path: 'gallery', component: GalleryComponent },
  { path: '', redirectTo: '/about', pathMatch: 'full' },
  { path: 'contact-us', component: NewContactUsComponent },
  { path: '', redirectTo: '/contact-us', pathMatch: 'full' },
  { path: 'about-us', component: NewAboutUsComponent },
  { path: '', redirectTo: '/about-us', pathMatch: 'full' },
  { path: 'why-us', component: WhyUsComponent },
  { path: '', redirectTo: '/why-us', pathMatch: 'full' },
  { path: 'service-port', component: ServicePortfolioComponent },
  { path: '', redirectTo: 'service-port', pathMatch: 'full' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routingComponents = [AboutComponent, ServiceComponent, GalleryComponent, NewContactUsComponent, NewAboutUsComponent]
